import React, { Suspense, lazy } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { usePrislistaPanel } from '../../../contexts/PrislistaPanelContext';
import { useDockadPanel } from '../../../contexts/DockadePanelerContext';

const PANEL_BREDD_REM = 24; // sm:w-96

// Samma komponent som Dashboard och kundvyn bygger på — en andra kopia av
// CRUD:en hade garanterat drivit isär.
const PrislistaHantering = lazy(() => import('./PrislistaHantering'));

const TILLATNA_ROLLER = ['inredningsarkitekt', 'admin'];

/**
 * IA-prislistan som dockad panel till höger, byggd som ArbetsbeskrivningSidebar
 * i rumsbeskrivningen: ingen overlay och inget som fångar klick utanför.
 * Resten av portalen går att använda som vanligt medan listan står uppslagen —
 * det är hela poängen, IA slår upp vad något kostar mitt i ett annat arbete.
 *
 * Monteras en gång i App, utanför Routes, så att den överlever navigering.
 *
 * useDockadPanel sköter två saker: modalerna krymps så att de hamnar bredvid
 * panelen i stället för under den, och en andra öppen panel läggs till vänster
 * om den här i stället för ovanpå. Se DockadePanelerContext och index.css.
 */
const PrislistaPanel = () => {
  const { user } = useAuth();
  const { oppen, stang } = usePrislistaPanel();

  const synlig = oppen && TILLATNA_ROLLER.includes(user?.role);
  const { hoger, topp } = useDockadPanel('prislista', synlig, PANEL_BREDD_REM);

  if (!synlig) return null;

  return (
    <div
      className="dockad-panel fixed right-0 w-full sm:w-96 bg-gray-50 shadow-2xl z-40 sm:z-[55] flex flex-col border-l border-gray-200"
      style={{ '--panel-hoger': `${hoger}rem`, top: topp, height: `calc(100% - ${topp}px)` }}
    >
      <div className="flex-shrink-0 flex items-start justify-between gap-4 px-4 py-3 bg-white border-b border-gray-200">
        <div>
          <h2 className="text-base font-semibold text-gray-900">IA-prislista</h2>
          <p className="text-xs text-gray-500 mt-0.5">Kunden ser samma poster under Ritningar</p>
        </div>
        <button
          onClick={stang}
          className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
          aria-label="Stäng prislistan"
          title="Stäng"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4">
        <Suspense fallback={<div className="text-sm text-gray-500 py-8 text-center">Laddar prislistan…</div>}>
          <PrislistaHantering visaRubrik={false} kompakt />
        </Suspense>
      </div>
    </div>
  );
};

export default PrislistaPanel;
